import Slot from './Slot';
var TimeTablePlugin = /*@__PURE__*/ (function () {
    function TimeTablePlugin(element) {
        var _this = this;
        this.load = function (timeslots, time) {
            _this.timeslot = time;
            for (var _i = 0, _a = _this.slots; _i < _a.length; _i++) {
                var slot = _a[_i];
                slot.remove();
            }
            _this.slots = [];
            for (var i = 0; i < timeslots.length; i++) {
                var slot = new Slot(i, timeslots[i]);
                slot.onClick(function (i, timeslot) {
                    for (var _i = 0, _a = _this.slots; _i < _a.length; _i++) {
                        var slot_1 = _a[_i];
                        slot_1.deactivate();
                    }
                    _this.slots[i].activate();
                    _this.changeTimeSlotEvt(timeslot, i);
                });
                _this.slots.push(slot);
            }
            var margin = 6 - timeslots.length % 6;
            if (margin === 6) {
                margin = 0;
            }
            for (var i = 0; i < margin; i++) {
                var slot = new Slot(-1, '-');
                slot.disable();
                _this.slots.push(slot);
            }
            _this.render();
        };
        this.disable = function () {
            jQuery(_this.element).hide().removeClass(TimeTablePlugin.LOADING_END_CLASS);
        };
        this.render = function () {
            jQuery(_this.element).find('[data-slot-items]').html('');
            for (var _i = 0, _a = _this.slots; _i < _a.length; _i++) {
                var slot = _a[_i];
                jQuery(_this.element).find('[data-slot-items]').append(jQuery(slot.getElement()));
            }
            jQuery(_this.element).find('[data-timeslot]').html(_this.timeslot);
            jQuery(_this.element).addClass('initialized');
            _this.deactivateLoadingState();
        };
        this.activateLoadingState = function () {
            _this.loading = true;
            jQuery(_this.element)
                .find('.loading-indicator')
                .hide();
        };
        this.deactivateLoadingState = function () {
            jQuery(_this.element).show();
            setTimeout(function () {
                jQuery(_this.element).addClass(TimeTablePlugin.LOADING_END_CLASS);
            }, 100);
        };
        this.onChangeTimeSlot = function (callback) {
            _this.changeTimeSlotEvt = callback;
        };
        this.element = element;
        this.slots = [];
        this.loading = false;
        this.timeslot = '30';
        jQuery(this.element).hide().addClass(TimeTablePlugin.LOADING_START_CLASS);
    }
    TimeTablePlugin.LOADING_START_CLASS = 'loading-start';
    TimeTablePlugin.LOADING_END_CLASS = 'loading-end';
    return TimeTablePlugin;
}());
export default TimeTablePlugin;



//////////////////
// WEBPACK FOOTER
// ./app/bundles/appointman/app/ts/plugins/TimeTable/index.ts
// module id = null
// module chunks = 